import React from 'react';
import { useParams } from 'react-router-dom';

import AdminsPage from './AdminsPage';

const AdminsModalRoute: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const mode = id ? 'edit' : 'create';

  return (
    <AdminsPage
      initialModal={{ mode, adminId: id }}
      modalReturnTo="/admins"
    />
  );
};

export default AdminsModalRoute;
